// // src/pages/ProjectDetail.tsx
// import React, { useEffect, useMemo, useState } from "react";
// import { useParams, Link, useSearchParams } from "react-router-dom";
// import Header from "../components/Header";
// import Footer from "../components/Footer";
// import { projects } from "../data/projects";
// import "./ProjectDetail.css";

// // ---- Flexible Plans Media Types (backward-compatible) ----
// type VideoSource = { src: string; type?: string };
// type PlanMedia =
//   | { kind: "image"; src: string; alt?: string }
//   | {
//       kind: "video";
//       poster?: string;
//       sources: VideoSource | VideoSource[];
//       autoPlay?: boolean;
//       loop?: boolean;
//       muted?: boolean;
//       playsInline?: boolean;
//     };

// // ---- Filters shared with Projects page ----
// type LocFilter = "all" | "inside" | "outside";
// const normalizeTypes = (t: any): string[] => (!t ? [] : Array.isArray(t) ? t : [t]);
// const isInsideLebanon = (location?: string) =>
//   typeof location === "string" && /(^|[\s,|.-])lebanon([\s,|.-]|$)/i.test(location);

// const ProjectDetail: React.FC = () => {
//   const { slug } = useParams<{ slug: string }>();

//   // ===== read filters from the URL (default to "all")
//   const [searchParams] = useSearchParams();
//   const locFilter: LocFilter = (searchParams.get("loc") as LocFilter) || "all";
//   const typesParam = searchParams.get("types") || "";
//   const typeFilter = typesParam ? typesParam.split(",").filter(Boolean) : [];

//   // ===== compute filtered list using the same logic as Projects page
//   const filtered = useMemo(() => {
//     return projects.filter((p: any) => {
//       if (locFilter === "inside" && !isInsideLebanon(p.location)) return false;
//       if (locFilter === "outside" && isInsideLebanon(p.location)) return false;
//       if (typeFilter.length === 0) return true;
//       const t = normalizeTypes(p.type).map((s) => s.toLowerCase());
//       return typeFilter.some((sel) => t.includes(sel.toLowerCase()));
//     });
//   }, [locFilter, typeFilter]);

//   // ===== current, prev, next from the filtered list
//   const idx = filtered.findIndex((p) => p.slug === slug);
//   const project = idx >= 0 ? filtered[idx] : projects.find((p) => p.slug === slug); // fallback
//   const prev = idx > 0 ? filtered[idx - 1] : null;
//   const next = idx >= 0 && idx < filtered.length - 1 ? filtered[idx + 1] : null;

//   // ===== build query string to preserve filters on all links
//   const resultsQuery = useMemo(() => {
//     const sp = new URLSearchParams();
//     sp.set("loc", locFilter);
//     if (typeFilter.length) sp.set("types", typeFilter.join(","));
//     return `?${sp.toString()}`;
//   }, [locFilter, typeFilter]);

//   // ---------------- GALLERY LIGHTBOX (hooks must be before any return)
//   const [lightboxIdx, setLightboxIdx] = useState<number | null>(null);
//   const images = project?.gallery ?? [];
//   const [isoOpenSrc, setIsoOpenSrc] = useState<string | null>(null);

//   useEffect(() => {
//     const onKey = (e: KeyboardEvent) => {
//       if (e.key === "Escape") setLightboxIdx(null);
//       if (e.key === "ArrowRight")
//         setLightboxIdx((i) => (i === null ? 0 : (i + 1) % images.length));
//       if (e.key === "ArrowLeft")
//         setLightboxIdx((i) =>
//           i === null ? 0 : (i - 1 + images.length) % images.length
//         );
//     };
//     if (lightboxIdx !== null) {
//       window.addEventListener("keydown", onKey);
//       return () => window.removeEventListener("keydown", onKey);
//     }
//   }, [lightboxIdx, images.length]);

//   // ---------------- PLANS OVERLAY/LIGHTBOX (also before any return)
//   const plansMediaArr = (project as any)?.plansMedia as PlanMedia[] | undefined;
//   const legacyPlanImage = (project as any)?.plans as string | undefined;
//   const legacyPlanVideosRaw = (project as any)?.plansVideo as string | string[] | undefined;
//   const legacyPlanVideos = Array.isArray(legacyPlanVideosRaw)
//     ? legacyPlanVideosRaw
//     : legacyPlanVideosRaw
//     ? [legacyPlanVideosRaw]
//     : [];
//   const hasPlansMedia = Array.isArray(plansMediaArr) && plansMediaArr.length > 0;

//   const plansCount = hasPlansMedia
//     ? plansMediaArr!.length
//     : legacyPlanVideos.length + (legacyPlanImage ? 1 : 0);

//   const [plansLbIdx, setPlansLbIdx] = useState<number | null>(null);

//   useEffect(() => {
//     const onKey = (e: KeyboardEvent) => {
//       if (e.key === "Escape") setPlansLbIdx(null);
//       if (e.key === "ArrowRight")
//         setPlansLbIdx((i) => (i === null ? 0 : (i + 1) % plansCount));
//       if (e.key === "ArrowLeft")
//         setPlansLbIdx((i) =>
//           i === null ? 0 : (i - 1 + plansCount) % plansCount
//         );
//     };
//     if (plansLbIdx !== null) {
//       window.addEventListener("keydown", onKey);
//       return () => window.removeEventListener("keydown", onKey);
//     }
//   }, [plansLbIdx, plansCount]);

//   const mimeFromExt = (url: string): string | undefined => {
//     const ext = url.split(".").pop()?.toLowerCase();
//     if (ext === "mp4") return "video/mp4";
//     if (ext === "webm") return "video/webm";
//     if (ext === "ogg" || ext === "ogv") return "video/ogg";
//     return undefined;
//   };

//   // If no project, render fallback (AFTER hooks)
//   if (!project) {
//     return (
//       <>
//         <Header />
//         <main className="pd-container pd-offset">
//           <h2>Project not found</h2>
//           <Link to={{ pathname: "/projects", search: resultsQuery }} className="pd-link">
//             ← Back to Projects
//           </Link>
//         </main>
//         <Footer />
//       </>
//     );
//   }

//   // ---- Helper renderers for flexible plans ----
//   const renderPlansSection = () => {
//     const hasLegacy = !!legacyPlanImage || legacyPlanVideos.length > 0;
//     if (!hasPlansMedia && !hasLegacy) return null;

//     return (
//       <section className="pd-plans-section">
//         <h2 className="pd-section-title">PLANS</h2>
//         <div className="pd-video-wrapper">
//           {hasPlansMedia
//             ? plansMediaArr!.map((item, idx) => {
//                 const open = () => setPlansLbIdx(idx);

//                 if (item.kind === "image") {
//                   return (
//                     <div
//                       className="pd-plans-item"
//                       key={`plan-img-${idx}`}
//                       onClick={open}
//                       style={{ cursor: "zoom-in" }}
//                     >
//                       <img
//                         src={item.src}
//                         alt={item.alt ?? `${project.title} plan`}
//                         loading="lazy"
//                         className="pd-plans-video"
//                       />
//                     </div>
//                   );
//                 }

//                 const {
//                   poster = "/images/plans-thumbnail.jpg",
//                   sources,
//                   autoPlay = true,
//                   loop = true,
//                   muted = true,
//                   playsInline = true,
//                 } = item;
//                 const sourcesArray = Array.isArray(sources) ? sources : [sources];

//                 return (
//                   <div className="pd-plans-item" key={`plan-vid-${idx}`}>
//                     <video
//                       autoPlay={autoPlay}
//                       loop={loop}
//                       muted={muted}
//                       playsInline={playsInline}
//                       preload="none"
//                       poster={poster}
//                       className="pd-plans-video"
//                     >
//                       {sourcesArray.map((s, i) => (
//                         <source key={i} src={s.src} type={s.type} />
//                       ))}
//                       Your browser does not support the video tag.
//                     </video>
//                     <button
//                       className="pd-plus-btn"
//                       onClick={open}
//                       aria-label="Open larger view"
//                     >
//                       <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
//                         <path
//                           d="M12 5v14M5 12h14"
//                           stroke="currentColor"
//                           strokeWidth="2"
//                           strokeLinecap="round"
//                         />
//                       </svg>
//                     </button>
//                   </div>
//                 );
//               })
//             : (() => {
//                 const nodes: React.ReactNode[] = [];
//                 let base = 0;

//                 legacyPlanVideos.forEach((url, i) => {
//                   nodes.push(
//                     <div className="pd-plans-item" key={`legacy-vid-${i}`}>
//                       <video
//                         autoPlay
//                         loop
//                         muted
//                         playsInline
//                         preload="none"
//                         poster="/images/plans-thumbnail.jpg"
//                         className="pd-plans-video"
//                       >
//                         <source src={url} type={mimeFromExt(url)} />
//                         Your browser does not support the video tag.
//                       </video>
//                       <button
//                         className="pd-plus-btn"
//                         onClick={() => setPlansLbIdx(base + i)}
//                         aria-label="Open larger view"
//                       >
//                         <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
//                           <path
//                             d="M12 5v14M5 12h14"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                           />
//                         </svg>
//                       </button>
//                     </div>
//                   );
//                 });
//                 base += legacyPlanVideos.length;

//                 if (legacyPlanImage) {
//                   nodes.push(
//                     <div className="pd-plans-item" key={`legacy-img`}>
//                       <img
//                         src={legacyPlanImage}
//                         alt={`${project.title} plan`}
//                         loading="lazy"
//                         className="pd-plans-video"
//                       />
//                       <button
//                         className="pd-plus-btn"
//                         onClick={() => setPlansLbIdx(base)}
//                         aria-label="Open larger view"
//                       >
//                         <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
//                           <path
//                             d="M12 5v14M5 12h14"
//                             stroke="currentColor"
//                             strokeWidth="2"
//                             strokeLinecap="round"
//                           />
//                         </svg>
//                       </button>
//                     </div>
//                   );
//                 }
//                 return nodes;
//               })()}
//         </div>
//       </section>
//     );
//   };

//   const renderIsometrySection = () => {
//     const isometryArr = (project as any)?.isometryMedia as PlanMedia[] | undefined;
//     if (!Array.isArray(isometryArr) || isometryArr.length === 0) return null;

//     return (
//       <section className="pd-isometry-section">
//         <h2 className="pd-section-title">ISOMETRY</h2>
//         <div className="pd-video-wrapper">
//           {isometryArr.map((item, idx) => {
//             if (item.kind === "image") {
//               return (
//                 <div
//                   className="pd-plans-item"
//                   key={`iso-img-${idx}`}
//                   onClick={() => setIsoOpenSrc(item.src)}
//                   style={{ cursor: "zoom-in" }}
//                 >
//                   <img
//                     src={item.src}
//                     alt={item.alt ?? `${project.title} isometry`}
//                     loading="lazy"
//                     className="pd-plans-video"
//                   />
//                 </div>
//               );
//             }
//             return null;
//           })}
//         </div>
//       </section>
//     );
//   };

//   return (
//     <>
//       <Header />

//       {/* HERO */}
//       <section className="pd-hero">
//         <div className="pd-hero-media" style={{ backgroundImage: `url(${project.cover})` }} />
//         <div className="pd-hero-gradient" />
//         <div className="pd-hero-content">
//           <div className="pd-breadcrumbs">
//             <Link to={{ pathname: "/projects", search: resultsQuery }} className="pd-link">
//               Projects
//             </Link>
//             <span> / </span>
//             <span>{project.title}</span>
//           </div>
//           <h1 className="pd-title">{project.title}</h1>

//           <div className="pd-chipbar">
//             {project.location && (
//               <span className="pd-chip">
//                 <strong>Location:</strong> {project.location}
//               </span>
//             )}
//             {project.status && (
//               <span className="pd-chip">
//                 <strong>Status:</strong> {project.status}
//               </span>
//             )}
//             {project.client && (
//               <span className="pd-chip">
//                 <strong>Client:</strong> {project.client}
//               </span>
//             )}
//             {project.year && (
//               <span className="pd-chip">
//                 <strong>Year:</strong> {project.year}
//               </span>
//             )}
//             {project.scope && (
//               <span className="pd-chip">
//                 <strong>Scope:</strong> {project.scope}
//               </span>
//             )}
//           </div>
//         </div>
//       </section>

//       <main className="pd-container pd-offset">
//         {/* TWO-COLUMN HEADER AREA */}
//         {!!(project.location || project.status || project.client || project.year || project.scope) ? (
//           <div className="pd-two">
//             <div>
//               {project.description && (
//                 <p className="project-lead">
//                   {project.description.split("\n").map((line, i) => (
//                     <React.Fragment key={i}>
//                       {line}
//                       <br />
//                     </React.Fragment>
//                   ))}
//                 </p>
//               )}
//             </div>
//           </div>
//         ) : (
//           project.description && (
//             <p className="project-lead">
//               {project.description.split("\n").map((line, i) => (
//                 <React.Fragment key={i}>
//                   {line}
//                   <br />
//                 </React.Fragment>
//               ))}
//             </p>
//           )
//         )}

//         {images.length > 0 && (
//           <section className="pd-gallery-fw">
//             <div className="pd-grid">
//               {images.map((src, i) => (
//                 <button
//                   key={i}
//                   className="pd-thumb"
//                   onClick={() => setLightboxIdx(i)}
//                   aria-label={`Open image ${i + 1}`}
//                 >
//                   <img src={src} alt={`${project.title} ${i + 1}`} loading="lazy" decoding="async" />
//                 </button>
//               ))}
//             </div>
//           </section>
//         )}

//         {/* PLANS (supports mixed image/video + overlay to open bigger) */}
//         {renderPlansSection()}
//         {renderIsometrySection()}

//         {/* Prev/Back/Next — derived from the FILTERED list */}
//         <nav className="pd-nav">
//           {prev ? (
//             <Link to={{ pathname: `/projects/${prev.slug}`, search: resultsQuery }} className="pd-link mute">
//               ← {prev.title}
//             </Link>
//           ) : (
//             <span />
//           )}
//           <Link to={{ pathname: "/projects", search: resultsQuery }} className="pd-link">
//             Back To Projects
//           </Link>
//           {next ? (
//             <Link to={{ pathname: `/projects/${next.slug}`, search: resultsQuery }} className="pd-link mute">
//               {next.title} →
//             </Link>
//           ) : (
//             <span />
//           )}
//         </nav>

//         {/* SITE LOCATION (only if available) */}
//         {project.mapEmbed && (
//           <section className="pd-location-section">
//             <h2 className="pd-section-title">Site Location</h2>
//             <div className="pd-map">
//               <iframe
//                 title={`${project.title} location`}
//                 src={project.mapEmbed}
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//                 allowFullScreen
//               />
//             </div>
//           </section>
//         )}
//       </main>

//       {/* GALLERY lightbox */}
//       {lightboxIdx !== null && images[lightboxIdx] && (
//         <div className="pd-lightbox" onClick={() => setLightboxIdx(null)} role="dialog" aria-modal="true">
//           <button className="pd-close" onClick={() => setLightboxIdx(null)} aria-label="Close">
//             ×
//           </button>
//           <button
//             className="pd-navbtn left"
//             onClick={(e) => {
//               e.stopPropagation();
//               setLightboxIdx((i) => (i! - 1 + images.length) % images.length);
//             }}
//             aria-label="Previous"
//           >
//             ‹
//           </button>
//           <img
//             className="pd-lightbox-img"
//             src={images[lightboxIdx]}
//             alt={`Image ${lightboxIdx + 1} of ${project.title}`}
//             onClick={(e) => e.stopPropagation()}
//           />
//           <button
//             className="pd-navbtn right"
//             onClick={(e) => {
//               e.stopPropagation();
//               setLightboxIdx((i) => (i! + 1) % images.length);
//             }}
//             aria-label="Next"
//           >
//             ›
//           </button>
//         </div>
//       )}

//       {/* PLANS lightbox */}
//       {plansLbIdx !== null && plansCount > 0 && (
//         <div className="pd-lightbox" onClick={() => setPlansLbIdx(null)} role="dialog" aria-modal="true">
//           <button className="pd-close" onClick={() => setPlansLbIdx(null)} aria-label="Close">
//             ×
//           </button>

//           <button
//             className="pd-navbtn left"
//             onClick={(e) => {
//               e.stopPropagation();
//               setPlansLbIdx((i) => (i! - 1 + plansCount) % plansCount);
//             }}
//             aria-label="Previous"
//           >
//             ‹
//           </button>

//           <div className="pd-lightbox-inner" onClick={(e) => e.stopPropagation()}>
//             {hasPlansMedia
//               ? (() => {
//                   const item = plansMediaArr![plansLbIdx];
//                   if (item.kind === "image") {
//                     return (
//                       <img
//                         className="pd-lightbox-img"
//                         src={item.src}
//                         alt={item.alt ?? `${project.title} plan`}
//                       />
//                     );
//                   }
//                   const sourcesArray = Array.isArray(item.sources) ? item.sources : [item.sources];
//                   return (
//                     <video
//                       className="pd-lightbox-video"
//                       controls
//                       playsInline
//                       preload="metadata"
//                       poster={item.poster ?? "/images/plans-thumbnail.jpg"}
//                     >
//                       {sourcesArray.map((s, i) => (
//                         <source key={i} src={s.src} type={s.type} />
//                       ))}
//                     </video>
//                   );
//                 })()
//               : (() => {
//                   if (plansLbIdx < legacyPlanVideos.length) {
//                     const url = legacyPlanVideos[plansLbIdx];
//                     return (
//                       <video
//                         className="pd-lightbox-video"
//                         controls
//                         playsInline
//                         preload="metadata"
//                         poster="/images/plans-thumbnail.jpg"
//                       >
//                         <source src={url} type={mimeFromExt(url)} />
//                       </video>
//                     );
//                   }
//                   return (
//                     <img className="pd-lightbox-img" src={legacyPlanImage!} alt={`${project.title} plan`} />
//                   );
//                 })()}
//           </div>

//           <button
//             className="pd-navbtn right"
//             onClick={(e) => {
//               e.stopPropagation();
//               setPlansLbIdx((i) => (i! + 1) % plansCount);
//             }}
//             aria-label="Next"
//           >
//             ›
//           </button>
//         </div>
//       )}

//       {/* ISOMETRY single-image lightbox */}
//       {isoOpenSrc && (
//         <div className="pd-lightbox" onClick={() => setIsoOpenSrc(null)} role="dialog" aria-modal="true">
//           <button className="pd-close" onClick={() => setIsoOpenSrc(null)} aria-label="Close">
//             ×
//           </button>
//           <img
//             className="pd-lightbox-img"
//             src={isoOpenSrc}
//             alt="Isometry enlarged"
//             onClick={(e) => e.stopPropagation()}
//           />
//         </div>
//       )}

//       <Footer />
//     </>
//   );
// };

// export default ProjectDetail;
import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { projects } from "../data/projects";
import "./ProjectDetail.css";

// ---- Flexible Plans Media Types (backward-compatible) ----
type VideoSource = { src: string; type?: string };
type PlanMedia =
  | { kind: "image"; src: string; alt?: string }
  | {
      kind: "video";
      poster?: string;
      sources: VideoSource | VideoSource[];
      autoPlay?: boolean;
      loop?: boolean;
      muted?: boolean;
      playsInline?: boolean;
    };

// ---- Filters shared with Projects page ----
type LocFilter = "all" | "inside" | "outside";
const normalizeTypes = (t: any): string[] => (!t ? [] : Array.isArray(t) ? t : [t]);
const isInsideLebanon = (location?: string) =>
  typeof location === "string" && /(^|[\s,|.-])lebanon([\s,|.-]|$)/i.test(location);

const ProjectDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();

  // ===== read filters from the URL (default to "all")
  const [searchParams] = useSearchParams();
  const locFilter: LocFilter = (searchParams.get("loc") as LocFilter) || "all";

  const typesParam = searchParams.get("types") || "";
  const typeFilter = typesParam ? typesParam.split(",").filter(Boolean) : [];

  const statusesParam = searchParams.get("statuses") || "";
  const statusFilter = statusesParam ? statusesParam.split(",").filter(Boolean) : [];

  // ===== compute filtered list using the same logic as Projects page
  const filtered = useMemo(() => {
    return projects.filter((p: any) => {
      // location
      if (locFilter === "inside" && !isInsideLebanon(p.location)) return false;
      if (locFilter === "outside" && isInsideLebanon(p.location)) return false;

      // type (OR)
      if (typeFilter.length) {
        const t = normalizeTypes(p.type).map((s) => s.toLowerCase());
        const typeHit = typeFilter.some((sel) => t.includes(sel.toLowerCase()));
        if (!typeHit) return false;
      }

      // status (OR)
      if (statusFilter.length) {
        if (!p.status || !statusFilter.includes(p.status)) return false;
      }

      return true;
    });
  }, [locFilter, typeFilter, statusFilter]);

  // ===== current, prev, next from the filtered list
  const idx = filtered.findIndex((p) => p.slug === slug);
  const project =
    idx >= 0 ? filtered[idx] : projects.find((p) => p.slug === slug); // fallback to show page even if filters hide it
  const prev = idx > 0 ? filtered[idx - 1] : null;
  const next = idx >= 0 && idx < filtered.length - 1 ? filtered[idx + 1] : null;

  // ===== build query string to preserve filters on all links
  const resultsQuery = useMemo(() => {
    const sp = new URLSearchParams();
    sp.set("loc", locFilter);
    if (typeFilter.length) sp.set("types", typeFilter.join(","));
    if (statusFilter.length) sp.set("statuses", statusFilter.join(","));
    const qs = sp.toString();
    return qs ? `?${qs}` : "";
  }, [locFilter, typeFilter, statusFilter]);

  // ---------------- GALLERY LIGHTBOX (hooks must be before any return)
  const [lightboxIdx, setLightboxIdx] = useState<number | null>(null);
  const images = project?.gallery ?? [];
  const [isoOpenSrc, setIsoOpenSrc] = useState<string | null>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setLightboxIdx(null);
      if (e.key === "ArrowRight")
        setLightboxIdx((i) => (i === null ? 0 : (i + 1) % images.length));
      if (e.key === "ArrowLeft")
        setLightboxIdx((i) =>
          i === null ? 0 : (i - 1 + images.length) % images.length
        );
    };
    if (lightboxIdx !== null) {
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    }
  }, [lightboxIdx, images.length]);

  // ---------------- PLANS OVERLAY/LIGHTBOX (also before any return)
  const plansMediaArr = (project as any)?.plansMedia as PlanMedia[] | undefined;
  const legacyPlanImage = (project as any)?.plans as string | undefined;
  const legacyPlanVideosRaw = (project as any)?.plansVideo as string | string[] | undefined;
  const legacyPlanVideos = Array.isArray(legacyPlanVideosRaw)
    ? legacyPlanVideosRaw
    : legacyPlanVideosRaw
    ? [legacyPlanVideosRaw]
    : [];
  const hasPlansMedia = Array.isArray(plansMediaArr) && plansMediaArr.length > 0;

  const plansCount = hasPlansMedia
    ? plansMediaArr!.length
    : legacyPlanVideos.length + (legacyPlanImage ? 1 : 0);

  const [plansLbIdx, setPlansLbIdx] = useState<number | null>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setPlansLbIdx(null);
      if (e.key === "ArrowRight")
        setPlansLbIdx((i) => (i === null ? 0 : (i + 1) % plansCount));
      if (e.key === "ArrowLeft")
        setPlansLbIdx((i) =>
          i === null ? 0 : (i - 1 + plansCount) % plansCount
        );
    };
    if (plansLbIdx !== null) {
      window.addEventListener("keydown", onKey);
      return () => window.removeEventListener("keydown", onKey);
    }
  }, [plansLbIdx, plansCount]);

  const mimeFromExt = (url: string): string | undefined => {
    const ext = url.split(".").pop()?.toLowerCase();
    if (ext === "mp4") return "video/mp4";
    if (ext === "webm") return "video/webm";
    if (ext === "ogg" || ext === "ogv") return "video/ogg";
    return undefined;
  };

  // If no project, render fallback (AFTER hooks)
  if (!project) {
    return (
      <>
        <Header />
        <main className="pd-container pd-offset">
          <h2>Project not found</h2>
          <Link to={{ pathname: "/projects", search: resultsQuery }} className="pd-link">
            ← Back to Projects
          </Link>
        </main>
        <Footer />
      </>
    );
  }

  // ---- Helper renderers for flexible plans ----
  const renderPlansSection = () => {
    const hasLegacy = !!legacyPlanImage || legacyPlanVideos.length > 0;
    if (!hasPlansMedia && !hasLegacy) return null;

    return (
      <section className="pd-plans-section">
        <h2 className="pd-section-title">PLANS</h2>
        <div className="pd-video-wrapper">
          {hasPlansMedia
            ? plansMediaArr!.map((item, idx) => {
                const open = () => setPlansLbIdx(idx);

                if (item.kind === "image") {
                  return (
                    <div
                      className="pd-plans-item"
                      key={`plan-img-${idx}`}
                      onClick={open}
                      style={{ cursor: "zoom-in" }}
                    >
                      <img
                        src={item.src}
                        alt={item.alt ?? `${project.title} plan`}
                        loading="lazy"
                        className="pd-plans-video"
                      />
                    </div>
                  );
                }

                const {
                  poster = "/images/plans-thumbnail.jpg",
                  sources,
                  autoPlay = true,
                  loop = true,
                  muted = true,
                  playsInline = true,
                } = item;
                const sourcesArray = Array.isArray(sources) ? sources : [sources];

                return (
                  <div className="pd-plans-item" key={`plan-vid-${idx}`}>
                    <video
                      autoPlay={autoPlay}
                      loop={loop}
                      muted={muted}
                      playsInline={playsInline}
                      preload="none"
                      poster={poster}
                      className="pd-plans-video"
                    >
                      {sourcesArray.map((s, i) => (
                        <source key={i} src={s.src} type={s.type} />
                      ))}
                      Your browser does not support the video tag.
                    </video>
                    <button
                      className="pd-plus-btn"
                      onClick={open}
                      aria-label="Open larger view"
                    >
                      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                        <path
                          d="M12 5v14M5 12h14"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                        />
                      </svg>
                    </button>
                  </div>
                );
              })
            : (() => {
                const nodes: React.ReactNode[] = [];
                let base = 0;

                legacyPlanVideos.forEach((url, i) => {
                  nodes.push(
                    <div className="pd-plans-item" key={`legacy-vid-${i}`}>
                      <video
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="none"
                        poster="/images/plans-thumbnail.jpg"
                        className="pd-plans-video"
                      >
                        <source src={url} type={mimeFromExt(url)} />
                        Your browser does not support the video tag.
                      </video>
                      <button
                        className="pd-plus-btn"
                        onClick={() => setPlansLbIdx(base + i)}
                        aria-label="Open larger view"
                      >
                        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                          <path
                            d="M12 5v14M5 12h14"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    </div>
                  );
                });
                base += legacyPlanVideos.length;

                if (legacyPlanImage) {
                  nodes.push(
                    <div className="pd-plans-item" key={`legacy-img`}>
                      <img
                        src={legacyPlanImage}
                        alt={`${project.title} plan`}
                        loading="lazy"
                        className="pd-plans-video"
                      />
                      <button
                        className="pd-plus-btn"
                        onClick={() => setPlansLbIdx(base)}
                        aria-label="Open larger view"
                      >
                        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                          <path
                            d="M12 5v14M5 12h14"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    </div>
                  );
                }
                return nodes;
              })()}
        </div>
      </section>
    );
  };

  const renderIsometrySection = () => {
    const isometryArr = (project as any)?.isometryMedia as PlanMedia[] | undefined;
    if (!Array.isArray(isometryArr) || isometryArr.length === 0) return null;

    return (
      <section className="pd-isometry-section">
        <h2 className="pd-section-title">ISOMETRY</h2>
        <div className="pd-video-wrapper">
          {isometryArr.map((item, idx) => {
            if (item.kind === "image") {
              return (
                <div
                  className="pd-plans-item"
                  key={`iso-img-${idx}`}
                  onClick={() => setIsoOpenSrc(item.src)}
                  style={{ cursor: "zoom-in" }}
                >
                  <img
                    src={item.src}
                    alt={item.alt ?? `${project.title} isometry`}
                    loading="lazy"
                    className="pd-plans-video"
                  />
                </div>
              );
            }
            return null;
          })}
        </div>
      </section>
    );
  };

  return (
    <>
      <Header />

      {/* HERO */}
      <section className="pd-hero">
        <div className="pd-hero-media" style={{ backgroundImage: `url(${project.cover})` }} />
        <div className="pd-hero-gradient" />
        <div className="pd-hero-content">
          <div className="pd-breadcrumbs">
            <Link to={{ pathname: "/projects", search: resultsQuery }} className="pd-link">
              Projects
            </Link>
            <span> / </span>
            <span>{project.title}</span>
          </div>
          <h1 className="pd-title">{project.title}</h1>

          <div className="pd-chipbar">
            {project.location && (
              <span className="pd-chip">
                <strong>Location:</strong> {project.location}
              </span>
            )}
            {project.status && (
              <span className="pd-chip">
                <strong>Status:</strong> {project.status}
              </span>
            )}
            {project.client && (
              <span className="pd-chip">
                <strong>Client:</strong> {project.client}
              </span>
            )}
            {project.year && (
              <span className="pd-chip">
                <strong>Year:</strong> {project.year}
              </span>
            )}
            {project.scope && (
              <span className="pd-chip">
                <strong>Scope:</strong> {project.scope}
              </span>
            )}
          </div>
        </div>
      </section>

      <main className="pd-container pd-offset">
        {/* TWO-COLUMN HEADER AREA */}
        {!!(project.location || project.status || project.client || project.year || project.scope) ? (
          <div className="pd-two pd-two--single">
            <div>
              {project.description && (
                <p className="project-lead">
                  {project.description.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </p>
              )}
            </div>
          </div>
        ) : (
          project.description && (
            <p className="project-lead">
              {project.description.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
          )
        )}

        {images.length > 0 && (
          <section className="pd-gallery-fw">
            <div className="pd-grid">
              {images.map((src, i) => (
                <button
                  key={i}
                  className="pd-thumb"
                  onClick={() => setLightboxIdx(i)}
                  aria-label={`Open image ${i + 1}`}
                >
                  <img src={src} alt={`${project.title} ${i + 1}`} loading="lazy" decoding="async" />
                </button>
              ))}
            </div>
          </section>
        )}

        {/* PLANS */}
        {renderPlansSection()}
        {renderIsometrySection()}

        {/* Prev/Back/Next — derived from the FILTERED list */}
        <nav className="pd-nav">
          {prev ? (
            <Link to={{ pathname: `/projects/${prev.slug}`, search: resultsQuery }} className="pd-link mute">
              ← {prev.title}
            </Link>
          ) : (
            <span />
          )}
          <Link to={{ pathname: "/projects", search: resultsQuery }} className="pd-link">
            Back To Projects
          </Link>
          {next ? (
            <Link to={{ pathname: `/projects/${next.slug}`, search: resultsQuery }} className="pd-link mute">
              {next.title} →
            </Link>
          ) : (
            <span />
          )}
        </nav>

        {/* SITE LOCATION */}
        {project.mapEmbed && (
          <section className="pd-location-section">
            <h2 className="pd-section-title">Site Location</h2>
            <div className="pd-map">
              <iframe
                title={`${project.title} location`}
                src={project.mapEmbed}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
          </section>
        )}
      </main>

      {/* GALLERY lightbox */}
      {lightboxIdx !== null && images[lightboxIdx] && (
        <div className="pd-lightbox" onClick={() => setLightboxIdx(null)} role="dialog" aria-modal="true">
          <button className="pd-close" onClick={() => setLightboxIdx(null)} aria-label="Close">
            ×
          </button>
          <button
            className="pd-navbtn left"
            onClick={(e) => {
              e.stopPropagation();
              setLightboxIdx((i) => (i! - 1 + images.length) % images.length);
            }}
            aria-label="Previous"
          >
            ‹
          </button>
          <img
            className="pd-lightbox-img"
            src={images[lightboxIdx]}
            alt={`Image ${lightboxIdx + 1} of ${project.title}`}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="pd-navbtn right"
            onClick={(e) => {
              e.stopPropagation();
              setLightboxIdx((i) => (i! + 1) % images.length);
            }}
            aria-label="Next"
          >
            ›
          </button>
        </div>
      )}

      {/* PLANS lightbox */}
      {plansLbIdx !== null && plansCount > 0 && (
        <div className="pd-lightbox" onClick={() => setPlansLbIdx(null)} role="dialog" aria-modal="true">
          <button className="pd-close" onClick={() => setPlansLbIdx(null)} aria-label="Close">
            ×
          </button>

          <button
            className="pd-navbtn left"
            onClick={(e) => {
              e.stopPropagation();
              setPlansLbIdx((i) => (i! - 1 + plansCount) % plansCount);
            }}
            aria-label="Previous"
          >
            ‹
          </button>

          <div className="pd-lightbox-inner" onClick={(e) => e.stopPropagation()}>
            {hasPlansMedia
              ? (() => {
                  const item = plansMediaArr![plansLbIdx];
                  if (item.kind === "image") {
                    return (
                      <img
                        className="pd-lightbox-img"
                        src={item.src}
                        alt={item.alt ?? `${project.title} plan`}
                      />
                    );
                  }
                  const sourcesArray = Array.isArray(item.sources) ? item.sources : [item.sources];
                  return (
                    <video
                      className="pd-lightbox-video"
                      controls
                      playsInline
                      preload="metadata"
                      poster={item.poster ?? "/images/plans-thumbnail.jpg"}
                    >
                      {sourcesArray.map((s, i) => (
                        <source key={i} src={s.src} type={s.type} />
                      ))}
                    </video>
                  );
                })()
              : (() => {
                  if (plansLbIdx < legacyPlanVideos.length) {
                    const url = legacyPlanVideos[plansLbIdx];
                    return (
                      <video
                        className="pd-lightbox-video"
                        controls
                        playsInline
                        preload="metadata"
                        poster="/images/plans-thumbnail.jpg"
                      >
                        <source src={url} type={mimeFromExt(url)} />
                      </video>
                    );
                  }
                  return (
                    <img className="pd-lightbox-img" src={legacyPlanImage!} alt={`${project.title} plan`} />
                  );
                })()}
          </div>

          <button
            className="pd-navbtn right"
            onClick={(e) => {
              e.stopPropagation();
              setPlansLbIdx((i) => (i! + 1) % plansCount);
            }}
            aria-label="Next"
          >
            ›
          </button>
        </div>
      )}

      {/* ISOMETRY single-image lightbox */}
      {isoOpenSrc && (
        <div className="pd-lightbox" onClick={() => setIsoOpenSrc(null)} role="dialog" aria-modal="true">
          <button className="pd-close" onClick={() => setIsoOpenSrc(null)} aria-label="Close">
            ×
          </button>
          <img
            className="pd-lightbox-img"
            src={isoOpenSrc}
            alt="Isometry enlarged"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </>
  );
};

export default ProjectDetail;
